module.exports = __webpack_public_path__ + "static/img/empty.24915db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.png
// module id = Bm30
// module chunks = 3